import { IconMap } from 'components/ui'
import { Network } from 'types/entities'

export enum SupportedChainId {
  MAINNET = 1,
  GOERLI = 5,
}

interface L1ChainInfo {
  readonly explorer: string
  readonly label: string
  readonly symbol: string
  readonly name: string
  readonly shortName: string
  readonly network: string
  readonly icon: IconMap
  readonly blockDuration: number
  readonly id: Network
  readonly isEstimateGas: boolean
}

type ChainInfo = { readonly [SupportedChainId: number]: L1ChainInfo }

export const CHAIN_INFO: ChainInfo = {
  [SupportedChainId.MAINNET]: {
    explorer: 'https://etherscan.io/',
    label: 'Mainnet',
    symbol: 'ETH',
    name: 'ethereum',
    shortName: 'eth',
    icon: 'eth',
    network: 'Mainnet',
    blockDuration: 12_000,
    id: Network.ETH_MAINNET,
    isEstimateGas: true,
  },
  [SupportedChainId.GOERLI]: {
    explorer: 'https://goerli.etherscan.io/',
    label: 'Mainnet',
    symbol: 'GöETH',
    name: 'Goerli',
    shortName: 'goEth',
    icon: 'goerli',
    network: 'Göerli',
    blockDuration: 12_000,
    id: Network.ETH_GOERLI,
    isEstimateGas: true,
  },
}

export const RPC_LIST: Record<number, string> = {
  [SupportedChainId.MAINNET]: 'https://mainnet.infura.io/v3/d83b0679fe374e9b941d63e97e8ba131',
  [SupportedChainId.GOERLI]: 'https://goerli.infura.io/v3/d83b0679fe374e9b941d63e97e8ba131',
}
